export function isLogin() {
    const token = getToken();
    if (token) {
        return true;
    } else {
        return false;
    }
}

export function getToken() {
    return window.localStorage.getItem('token')
}

export function saveUserInfo(data) {
    window.localStorage.setItem('userInfo', JSON.stringify(data))
}

export function saveCacheAuthToken(authToken) {
    window.localStorage.setItem('authToken', authToken)
}

export function getCacheAuthToken() {
    return window.localStorage.getItem('authToken')
}

export function removeCacheAuthToken() {
    return window.localStorage.removeItem('authToken')
}

export function saveCacheToken(token) {
    window.localStorage.setItem('token', token)
}
export function getUserToken() {
    return window.localStorage.getItem('token')
}
export function removeCacheToken() {
    window.localStorage.removeItem('token')
}


export function getUserVipLevel() {
    if (!getUserToken) return ''
    if (!window.localStorage.getItem('userInfo')) return ''
    return JSON.parse(window.localStorage.getItem('userInfo')).vipLevel
}

export function getUserPhone() {
    if (!getUserToken) return ''
    if (!window.localStorage.getItem('userInfo')) return ''
    return JSON.parse(window.localStorage.getItem('userInfo')).phone
}

export function getUserInfo() {
    if (!getUserToken) return {}
    if (!window.localStorage.getItem('userInfo')) return {}
    return JSON.parse(window.localStorage.getItem('userInfo'))
}

export function setWxPayInfo(data) {
    window.localStorage.setItem('wxPayInfo', JSON.stringify(data))
}

export function getCacheWxPayInfo() {
    const wxPayInfoJson = window.localStorage.getItem('wxPayInfo')
    if (wxPayInfoJson) {
        return JSON.parse(wxPayInfoJson)
    }
    return null;
}

export function removeCacheWxPayInfo() {
    window.localStorage.removeItem('wxPayInfo')
}

export function saveAlipayFormHtml(data) {
    window.localStorage.setItem('alipayInfo', data);
}

export function getAlipayFormHtml() {
    return window.localStorage.getItem('alipayInfo')
}

export function removeAlipayFormHtml() {
    window.localStorage.removeItem('alipayInfo')
}

export function setWxLoginState(state) {
    window.localStorage.setItem('wxLoginState', state)
}

export function getWxLoginState() {
    return window.localStorage.getItem('wxLoginState')
}

export function saveAuthHandel(params) {
    window.localStorage.setItem('authHandel', params)
}
export function getAuthHandel() {
    return window.localStorage.getItem('authHandel')
}
export function removeAuthHandel() {
    return window.localStorage.removeItem('authHandel')
}

export function cacheSaveAppId(appId) {
    window.localStorage.setItem('auth-app-id', appId)
}
export function cacheGetAppId() {
    return window.localStorage.getItem('auth-app-id')
}
export function cacheRemoveAppId() {
    window.localStorage.removeItem('auth-app-id')
}

export function cacheSaveTargetUrl(targetUrl) {
    window.localStorage.setItem('auth-target-url', targetUrl)
}
export function cacheGetTargetUrl() {
    return window.localStorage.getItem('auth-target-url')
}
export function cacheRemoveTargetUrl() {
    window.localStorage.removeItem('auth-target-url')
}

//传入URL，返回指定名称的参数值，URL为空时，抓取当前URL
export function getUrlParam(paramName, url) {
    if (!url) {
        url = window.location.href;
    }
    const urlObj = new URL(url);
    return urlObj.searchParams.get(paramName);
}